import { render, staticRenderFns } from "./EnterpriseBasicDatadata.vue?vue&type=template&id=5dcf27c1&scoped=true&"
import script from "./EnterpriseBasicDatadata.vue?vue&type=script&lang=js&"
export * from "./EnterpriseBasicDatadata.vue?vue&type=script&lang=js&"
import style0 from "./EnterpriseBasicDatadata.vue?vue&type=style&index=0&id=5dcf27c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dcf27c1",
  null
  
)

export default component.exports